export const invoiceAttachmentsEn = {
  "attachments.title": "Invoice attachments",
  "attachments.choose": "Choose files to attach",
  "attachments.selected": "Files selected before saving",
  "attachments.limits": "Up to 20 files per invoice, 10 MB each. PDF, PNG, JPEG, WebP, TIFF, DOCX, XLSX, CSV, TXT and XML.",
  "attachments.upload": "Upload files", "attachments.download": "Download",
  "attachments.remove": "Remove", "attachments.removeSelected": "Remove from selection",
  "attachments.removeConfirm": "Remove this attachment from the invoice? The action is recorded in the audit history.",
  "attachments.noFiles": "No files attached to this invoice.",
  "attachments.loading": "Loading invoice files…",
  "attachments.uploadError": "Could not upload all files. Retry with the remaining selection.",
  "attachments.downloadError": "Could not download the file. Try again.",
  "attachments.removeError": "Could not remove the attachment. Try again.",
  "attachments.loadError": "Could not load invoice attachments.",
  "attachments.draftUploadError": "The invoice draft was saved, but some files did not upload. Save again to retry the remaining files.",
} as const

export const invoiceAttachmentsEt: Record<keyof typeof invoiceAttachmentsEn, string> = {
  "attachments.title": "Arve manused",
  "attachments.choose": "Vali arvele lisatavad failid",
  "attachments.selected": "Enne salvestamist valitud failid",
  "attachments.limits": "Kuni 20 faili arve kohta, igaüks kuni 10 MB. PDF, PNG, JPEG, WebP, TIFF, DOCX, XLSX, CSV, TXT ja XML.",
  "attachments.upload": "Laadi failid üles", "attachments.download": "Laadi alla",
  "attachments.remove": "Eemalda", "attachments.removeSelected": "Eemalda valikust",
  "attachments.removeConfirm": "Kas eemaldada manus arvelt? Toiming salvestatakse auditi ajaloos.",
  "attachments.noFiles": "Sellel arvel pole manuseid.",
  "attachments.loading": "Arve manuste laadimine…",
  "attachments.uploadError": "Kõiki faile ei saanud üles laadida. Proovi ülejäänutega uuesti.",
  "attachments.downloadError": "Faili ei saanud alla laadida. Proovi uuesti.",
  "attachments.removeError": "Manust ei saanud eemaldada. Proovi uuesti.",
  "attachments.loadError": "Arve manuseid ei saanud laadida.",
  "attachments.draftUploadError": "Arve mustand salvestati, kuid osa failidest jäi üles laadimata. Ülejäänud failide lisamiseks salvesta uuesti.",
}

export const invoiceAttachmentsRu: Record<keyof typeof invoiceAttachmentsEn, string> = {
  "attachments.title": "Вложения к счёту",
  "attachments.choose": "Выберите файлы для счёта",
  "attachments.selected": "Файлы, выбранные перед сохранением",
  "attachments.limits": "До 20 файлов на счёт, не более 10 МБ каждый. PDF, PNG, JPEG, WebP, TIFF, DOCX, XLSX, CSV, TXT и XML.",
  "attachments.upload": "Загрузить файлы", "attachments.download": "Скачать",
  "attachments.remove": "Удалить", "attachments.removeSelected": "Убрать из выбора",
  "attachments.removeConfirm": "Удалить вложение из счёта? Действие останется в истории аудита.",
  "attachments.noFiles": "У этого счёта пока нет вложений.",
  "attachments.loading": "Загрузка вложений к счёту…",
  "attachments.uploadError": "Не все файлы удалось загрузить. Повторите попытку с оставшимися файлами.",
  "attachments.downloadError": "Не удалось скачать файл. Попробуйте ещё раз.",
  "attachments.removeError": "Не удалось удалить вложение. Попробуйте ещё раз.",
  "attachments.loadError": "Не удалось загрузить список вложений к счёту.",
  "attachments.draftUploadError": "Черновик счёта сохранён, но часть файлов не загрузилась. Сохраните его ещё раз, чтобы повторить загрузку оставшихся файлов.",
}
